import * as React from 'react';
import './index.css';
import { handleLXParamShop, landingPageMcShop, ShopBurying } from 'src/pages/homepage/shopLandingPage/request/lx';
import { handleLXParam, KingKongBurying, landingPageMc } from 'src/pages/homepage/landingPage/request/lx';
import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import { PageDatum } from '@/src/pages/homepage/shopLandingPage/conponent';
import { DynamicTagGroup } from '@/src/components/DynamicTag';
import { buildUrl } from '@/utils/buildUrl';
import { RichText } from '@wmfe/mach-pro-components-react';
import { MainPageBundleNameList } from '@/src/sub_packages/homepage/home_product_card_v2/constant';
import CommonDialog from '@/components/CommonDialog';
import AdFlagContainer from '@/components/AdFlagContainer';
import { requestFavorites } from '@/shop/shop_favorites/models/network';
import { URL } from '@/shop/shop_favorites/utils/service';
import { KEY_REFRESH_FAVORITE_INFO } from '@/shop/shop_favorites/utils/constant';
import { ShopStatus } from '@/components/HomePage/LandingPage/ItemCardV2/constan';
import { AdFlagExpKeyMap } from '@/components/AdFlagContainer/constant';
import {
  favoriteItemMC,
  favoriteItemMV,
  pressItemCancleFavoriteMC,
  pressItemCancleFavoriteMV
} from '@/shop/shop_favorites/statistics';
import { HIT_AD } from '@/src/sub_packages/common/BaseComponent/adReport';
import { toNumber } from 'lodash';
import { UserGetMode } from '@/src/pages/order/order_confirm/constant';
import { isSupportTransition } from '@/src/utils';
import ShopInfo from '../../FeedsCardInfo/ShopInfoView';
import DeliveryInfo from '../../FeedsCardInfo/DeliveryInfoView';

const Toast = Mach.requireModule('Toast');
const EventCenter = Mach.requireModule('EventCenter');

interface Props {
  data: PageDatum;
  index: any;
  bizTraceId: string;
  lxData?: any;
  type: string;
  discountExpFlag: string;
  lxReportOnClick?: Function;
  isPickUp?: boolean;//判断是否是自提子包的样式（product_card_v2子包会传这个参数，其他不会）
  bundleName?: string;
}

interface State {
  imgTagWidth: number;
  shouldDynamicTagsTwoLines: boolean;
  showDialog: boolean;
}

const WMRouter = Mach.requireModule('Router');
const imageWidth = 120;
export default class ItemCardV2 extends React.PureComponent<Props, State> {
  sharedElementImageRef: any = null;

  constructor(props) {
    super(props);
    this.state = {
      imgTagWidth: 1,
      shouldDynamicTagsTwoLines: true
    };
  }

  gotoDetailPage(data: any) {
    const {
      bizTraceId, index, lxData = {}, type, isPickUp
    } = this.props;
    if (type === 'KingKong') {
      const commonParam = handleLXParam(data, index, bizTraceId);
      const lxParam = { ...commonParam, ...lxData };
      const biz = KingKongBurying.cardMC;
      landingPageMc(biz, lxParam);
    } else if (type === 'HomePage') {
      // 包含首页子包和自提子包，具体cid在外层区分
      if (this.props.lxReportOnClick) {
        this.props.lxReportOnClick();
      }
    } else {
      const commonParam = handleLXParamShop(data, index, bizTraceId);
      const lXData = data?.lxData || {}; // 外部传入的埋点字段
      let lxParam = commonParam;
      const biz = ShopBurying.cardMC;
      lxParam = { ...lxParam, ...lXData };
      landingPageMcShop(biz, lxParam, type);
    }
    const { shopId } = data || {};
    let shopInfoResponse = data?.shopInfoResponse;
    shopInfoResponse = { ...shopInfoResponse, checkList: !!shopInfoResponse };
    const userGetMode = isPickUp ? 'pickup' : 'delivery';
    const hasTransitionPic = shopInfoResponse?.logoUrl;
    const supportTransition = isSupportTransition(Mach.env.bundleName) && hasTransitionPic;
    const transition = supportTransition ? 1 : 0;
    if (supportTransition) {
      this.sharedElementImageRef?.didSelectedImageView?.();
    }
    // 自提跳链
    WMRouter.navigateTo(buildUrl(data.scheme, { shopId, userGetMode, transition }), { shopInfoResponse }, () => {});
  }
  textLength = 0;

  /**
   * 自提店铺名称
   */
  getShopNameContent = () => {
    const { data } = this.props;
    if (!data) return [];
    const pickUpIcon = this.getShopNameIcon(data);
    const content: any[] = [];
    // 间隔
    const placeholder = {
      type: 'placeholder',
      width: 4
    };
    const lineHeight = 21; // 行高：粗体行高较高
    // 自提标签
    if (pickUpIcon && pickUpIcon.picUrl) {
      content.push({
        type: 'image',
        src: pickUpIcon.picUrl,
        width: pickUpIcon.width || 0,
        height: pickUpIcon.height || 0,
        verticalOffset: Math.floor(pickUpIcon.height - lineHeight) * 0.5,
        verticalAlignment: 'center'
      });
      content.push(placeholder);
    }
    // 店铺名称
    if (data.name) {
      content.push({
        type: 'text',
        text: data.name,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        fontWeight: 700,
      });
    }
    return content;
  }

  /**
   * 获取店铺名称前缀标签
   */
  getShopNameIcon = (data) => {
    if (!data) {
      return null;
    }
    let pickUpIcon = data.pickUpIcon;
    if (data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
        || data?.shopStatus?.shopStatusCode === ShopStatus.OUT_OF_RANGE) {
      pickUpIcon = data.shopStatus?.shopStatusPic;
    }
    return pickUpIcon;
  }

  longPressItemCard = () => {
    if (!this.isShopFavoritesPage()) {
      return;
    }
    this.setState({
      showDialog: true
    });
    if (this.props.lxReportOnClick) {
      this.props.lxReportOnClick();
    }
  }

  isShopFavoritesPage = () => {
    const { bundleName } = this.props;
    return bundleName === MainPageBundleNameList.ShopFavorites;
  }

  render() {
    const { data, type } = this.props;
    // 两个落地页需要有卡片边距
    const containerStyle = (type === 'KingKong' || type === 'shop') ? 'root-container' : 'root-container-home-page';
    const { shopStatus } = data;
    return (
      <view>
        {data?.showNoMoreTip ? (
          <view key="noMoreCell" className="noMoreCell">
            <text className="noMoreTitle">{i18nClient.getText('shouye_bottom')}</text>
          </view>
        ) : (
          <view
            className={containerStyle}
            style={{ flexDirection: 'column' }}
            onClick={() => {
              this.gotoDetailPage(data);
            }}
            onLongPress={this.longPressItemCard}
          >
            {
              this.isShopFavoritesPage() ? (
                shopStatus?.shopStatusCode !== ShopStatus.OFFLINE ? (
                  this.renderItemCard()
                ) : (
                  this.renderOfflineInfo()
                )
              ) : this.renderItemCard()
            }
            {this.renderConfirmDialog()}
          </view>
        )}
      </view>
    );
  }

  renderItemCard = () => {
    const {
      data, isPickUp = false, type, index
    } = this.props;
    // const containerHeight = data?.recommendData ? 176 : 136;
    const deliveryTagImg = data?.promotionLabel?.promotionIconUrl;
    const deliveryTagText = data?.promotionLabel?.promotionText;
    const showDeliveryImgTag = (!data?.shopStatus?.shopStatusDesc) && deliveryTagText && deliveryTagImg;
    const { imgTagWidth } = this.state;

    const pickUpTagImg = data?.pickupPromotionLabel?.promotionIconUrl;
    const pickUpTagText = data?.pickupPromotionLabel?.promotionText;
    const showRestBg = data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
        || data?.shopStatus?.shopStatusCode == ShopStatus.OFFLINE
        || data?.shopStatus?.shopStatusCode == ShopStatus.OUT_OF_RANGE;
    const hitAd = data?.adInfo?.hitAd === HIT_AD;
    // 广告标实验key
    const adFlagExpKey = data?.adInfo?.expKey;
    const shopHeadImageUrl = data?.shopInfoResponse?.logoUrl;
    const height = Math.floor(Mach.env?.screenWidth * (9 / 16));
    const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`;
    const renderSharedElementImage = shopHeadImageUrl && isSupportTransition(Mach.env.bundleName);
    return (
      <view key="card" style={{ flexDirection: 'column' }}>
        <view
          className="itemContainer"
        >
          {/*图片+店铺信息区*/}
          <view style={{ flexDirection: 'row' }}>

            {/*商家主图*/}
            <view className="picturePart">
              {renderSharedElementImage ? (
                <shared-element-image
                  ref={(ref) => {
                    this.sharedElementImageRef = ref;
                  }}
                  cdnOptimizationSize={shopHeadImageCacheCDNParam}
                  className="interactive-transition-image"
                  resizeMode="scaleToFill"
                  placeholder="assets://placeholder/icon_placeholder_16:9.png"
                  src={
                    shopHeadImageUrl
                  }
                  error="assets://placeholder/icon_placeholder_16:9.png"
                />
              ) : null}
              <image
                className="itemImage"
                resizeMode="aspectFill"
                placeholder="assets://placeholder/icon_placeholder_1:1.png"
                src={
                  data?.shopMainPicUrl != null && data?.shopMainPicUrl !== ''
                    ? data?.shopMainPicUrl
                    : 'assets://placeholder/icon_placeholder_1:1.png'
                }
                error="assets://placeholder/icon_placeholder_1:1.png"
              />
              {/* 精选标签 */}
              {data?.brandPicInfo && (
                <image
                  style={{ height: data?.brandPicInfo?.height }}
                  className="brandPic" src={data?.brandPicInfo?.picUrl} resizeMode="heightFix"
                />
              )}

              {/* 广告标坑位 - 有腰封在腰封上方，没有在底部 */}
              {hitAd && AdFlagExpKeyMap.AD.has(adFlagExpKey) && (
                <view className="adFlagContainer-belt" style={{ bottom: (isPickUp || showDeliveryImgTag) ? 20 : 0 }}>
                  <AdFlagContainer adInfo={data?.adInfo} />
                </view>
              )}

              {/* 图片底部Tag */}
              {isPickUp ? (pickUpTagImg && pickUpTagText && (
                <view className="pickup-bottom-tag-container">
                  <image
                    resizeMode="stretch"
                    src={pickUpTagImg}
                    style={{ height: '100%', width: '100%' }}
                  />
                  <view className="pickup-bottomTag-container">
                    <text className="pickup-bottomTag-text" content={pickUpTagText} />
                  </view>
                </view>
              ))
                : (showDeliveryImgTag && (
                  <view className="bottom-tag-container">
                    <text
                      content={deliveryTagText}
                      className="bottomTag-text"
                      style={{ marginLeft: imgTagWidth + 4 }}
                    />
                  </view>
                ))}
              {showDeliveryImgTag && !isPickUp && (
                <view className="img-tag-container">
                  <image
                    resizeMode="heightFix"
                    onLayout={(size) => {
                      this.setState({
                        imgTagWidth: size.detail.width
                      });
                    }}
                    src={deliveryTagImg}
                    style={{ height: imageWidth }}
                  />
                </view>
              )}
              {showRestBg && (<view className="restBg" />)}
            </view>

            {/* 店铺信息区 */}
            <view>
              {isPickUp ? this.renderPickUpInfo() : this.renderNormalInfo()}
            </view>
          </view>
        </view>

        {/* 广告标坑位 - 暗点，商卡底部logo正下方 */}
        {hitAd && AdFlagExpKeyMap.DOT.has(adFlagExpKey) && (
          <view className="adFlagContainer-dot">
            <AdFlagContainer adInfo={data?.adInfo} />
          </view>
        )}

        {/* 广告标坑位 - 赞助，商卡右下角 */}
        {hitAd && AdFlagExpKeyMap.SPONSOR.has(adFlagExpKey) && (
          <view className="adFlagContainer-sponsor">
            <AdFlagContainer adInfo={data?.adInfo} />
          </view>
        )}

        {/* 热榜（自提无此项） */}
        {!isPickUp && this.renderRecommend()}
      </view>
    );
  }

  renderConfirmDialog() {
    const { showDialog } = this.state;
    const { data } = this.props;
    if (showDialog) {
      pressItemCancleFavoriteMV(data?.shopId || '-999');
    }
    return (
      <view>
        {showDialog && (
          <CommonDialog
            message={i18nClient.getText('favourites_remove_title')}
            leftBtnText={i18nClient.getText('favourites_remove_button2')}
            rightBtnText={i18nClient.getText('favourites_remove_button1')}
            onClickLeftBtn={() => {
              pressItemCancleFavoriteMC(data?.shopId || '-999');
              this.setState({
                showDialog: false
              });
            }}
            onClickRightBtn={() => {
              pressItemCancleFavoriteMC(data?.shopId || '-999');
              this.setState({
                showDialog: false
              });
              this.cancelFavorites();
            }}
            onClickMask={() => {
            }}
          />
        )}
      </view>
    );
  }

  cancelFavorites = () => {
    const { data } = this.props;
    requestFavorites(URL.cancelFavorite, data?.shopId, (response) => {
      if (response.code == 0) {
        Toast.show(response.message, 2);
        EventCenter.emit(KEY_REFRESH_FAVORITE_INFO);
      }
    });
  }

  renderNormalInfo = () => {
    const { data, index } = this.props;
    let rateIcon;
    if (data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
        || data?.shopStatus?.shopStatusCode === ShopStatus.OUT_OF_RANGE) {
      rateIcon = data.shopStatus?.shopStatusPic;
    }
    const showShopRate = data?.shopScoreInfo?.score;

    const { deviceModel } = Mach.env;
    let restrictOneLine = false;
    // fix to https://ones.sankuai.com/ones/product/33910/workItem/defect/detail/85912285?activeTabName=first&detailTabName=remark
    // 特殊机型店铺名称兼容
    if (['samsung@SM-A5360'].includes(deviceModel)) {
      restrictOneLine = true;
    }
    return (
      // iOS如果不写高度的话cell高度会被动态标签行数撑高回不去，基建大约在1.10版本会更新selfSizing属性动态修正cell高度，到时候尝试下。
      <view className={Mach.env.isIOS ? 'itemContent-maxHeight' : 'itemContent'}>
        <view className="content-view">
          {(rateIcon || data?.name)
          && (
            <view style={{ flexShrink: 0 }}>
              <RichText className="shopName" style={{ maxLines: restrictOneLine ? 1 : 2 }} content={this.getShopNameContent()} />
            </view>
          )}

          {this.renderShopInfo(data)}

          {this.renderDeliveryInfo(data)}
        </view>

        {/* 动态标签 */}

        {!!data?.promotionTags && (
          <view className="dynamic-tag-view" style={{ flexShrink: 1 }} key={`${data?.name}+${index}`}>
            <DynamicTagGroup {...data?.promotionTags?.discountTag} maxLines={this.shouldDynamicTagsTwoLines() ? 2 : 1} />
          </view>
        )}
      </view>
    );
  }

  renderOfflineInfo = () => {
    const { data } = this.props;
    const { shopStatus } = data;
    const showRestBg = data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
        || data?.shopStatus?.shopStatusCode == ShopStatus.OFFLINE
        || data?.shopStatus?.shopStatusCode == ShopStatus.OUT_OF_RANGE;
    return (
      <view className="itemContainer" style={{ flexDirection: 'row' }}>
        <view className="shop-offline-image">
          <image
            className="itemImage"
            resizeMode="aspectFill"
            placeholder="assets://placeholder/icon_placeholder_1:1.png"
            src={
              data?.shopMainPicUrl != null && data?.shopMainPicUrl !== ''
                ? data?.shopMainPicUrl
                : 'assets://placeholder/icon_placeholder_1:1.png'
            }
            error="assets://placeholder/icon_placeholder_1:1.png"
          />
          {showRestBg && (<view className="restBg" />)}
        </view>
        <view style={{ flexDirection: 'column' }} className="itemContent">
          <text className="shop-offline-status" content={shopStatus.shopStatusDesc} />
          <text className="shop-offline-name" content={data.name} />
        </view>
      </view>
    );
  }

  renderPickUpInfo = () => {
    const { data } = this.props;
    const showShopRate = data?.shopScoreInfo?.score;
    const pickUpIcon = this.getShopNameIcon(data); // 店铺名称前缀图标
    return (
      <view className="itemContent">
        <view className="content-view">
          {/* 店铺名称 */}
          {(pickUpIcon && pickUpIcon?.picUrl || data?.name) && <RichText className="shopName" content={this.getShopNameContent()} />}

          {/* 评分&最低消费金额&品类 */}
          <ShopInfo data={data} showRateInfo={false} setMarginTop={4} />

          {/* 出餐时间 */}
          {data?.diningReadyTimeDesc && (
            <view style={{ marginTop: 12 }}>
              <image className="shop-time-img" src={data?.diningReadyTimeIconUrl || 'assets://pickup/dining_ready_time_icon.png'} />
              <text className="detaileTitle">{data?.diningReadyTimeDesc}</text>
            </view>
          )}

          {/* 距离 */}
          {data?.distance?.desc
            && (
              <view style={{ marginTop: 4 }}>
                <image className="shop-distance-img" src={data?.distanceIconUrl || 'assets://pickup/dining_ready_distance_icon.png'} />
                <text className="detaileTitle">{data?.distance?.desc}</text>
              </view>
            )}
        </view>

        {/* 动态标签 */}
        {!!data?.promotionTags && (
          <view className="dynamic-tag-view">
            <DynamicTagGroup {...data?.promotionTags?.discountTag} />
          </view>
        )}
      </view>
    );
  }

  /**
   * 推荐菜
   * @returns
   */
  renderRecommend = () => {
    const { data } = this.props;
    return (
      <view>
        {data?.recommendData && (
          <view className="recommendRow">
            {data?.recommendData[0]?.renderStyle ? (
              <image-background
                resizeMode="scaleToFill"
                className="recommendRowBackground"
                src={data?.recommendData[0]?.renderStyle.backPicUrl}
              >
                <image className="recommendIcon" src={data.recommendData[0]?.renderStyle?.iconUrl} />
                <text
                  style={{
                    fontFamily: data?.recommendData[0]?.renderStyle?.fontType
                      ? data?.recommendData[0]?.renderStyle?.fontType
                      : 'Keeta-Regular',
                    fontSize: data?.recommendData[0]?.renderStyle?.fontSize
                      ? data?.recommendData[0]?.renderStyle?.fontSize
                      : 12,
                    color: data?.recommendData[0]?.renderStyle?.fontColor
                      ? data?.recommendData[0]?.renderStyle?.fontColor
                      : '#992600',
                  }}
                  className="recommendText"
                >
                  {data.recommendData[0]?.text}
                </text>
              </image-background>
            ) : null}
          </view>
        )}
      </view>
    );
  }

  renderDeliveryInfo = (dataInfo: any) => (
    <view>
      <DeliveryInfo data={dataInfo} showRateInfo={false} setMarginTop={12} />
    </view>
  )

  renderShopInfo = (dataInfo: any) => (
    <view>
      <ShopInfo data={dataInfo} showRateInfo={false} setMarginTop={4} />
    </view>
  )

  shouldDynamicTagsTwoLines = () => {
    const { data } = this.props;
    let realWidth = 0; let
      showTwoLines = true;
    const frameWidth = Mach.env.screenWidth - 148 - 22;
    // 判断标题行数
    const SLCommon = Mach.requireModule('SLCommon');
    const titleIcon = this.getShopNameIcon(data);
    if (titleIcon) {
      realWidth += titleIcon.width + 4;
    }

    const titleWidth = SLCommon.widthForText({
      fontFamily: 'KeeTa-Bold',
      content: data.name,
      fontSize: 16,
      bold: 1,
    });
    realWidth += titleWidth;
    const fixWidth = Mach.env.isIOS ? 2 : 6.5; // 一些机型宽度可能会算不准，这里加大下修正值
    showTwoLines = (realWidth + fixWidth) < frameWidth;
    // 判断第二行店铺信息行
    const {
      shopBasicLabelOrder = ['shopScoreInfo', 'shopSaleInfo', 'avgCostPrice', 'shopCategoryName', 'minCostPrice'], //展示顺序数组
    } = data;
    let showShopInfoLine = false; //是否展示信息行，需要根据shopBasicLabelOrder中的字段来判断是否展示
    if (shopBasicLabelOrder) {
      for (let i = 0; i < shopBasicLabelOrder.length; i++) {
        const typeName = shopBasicLabelOrder[i];
        if (typeName && data[typeName]) {
          showShopInfoLine = true;
        }
      }
    }
    showTwoLines = showShopInfoLine ? showTwoLines : true;

    // 判断第三行配送信息行数
    const {
      deliveryTimeDesc = '',
      distance = {}, // 距离
      deliveryFee = {},
      finalDeliveryFeeInfo = {},
    } = data;
    let showDeliveryLine = false;
    if (deliveryTimeDesc || distance || deliveryFee || finalDeliveryFeeInfo) {
      showDeliveryLine = true;
    }
    showTwoLines = showDeliveryLine ? showTwoLines : true;

    return showTwoLines;
  }
}
